import { useState } from "react";
import { motion } from "framer-motion";
import { Expand } from "lucide-react";
import { PROJECTS } from "@/content/site";
import { Reveal, MaskLine, EASE } from "./Reveal";
import { SectionHead } from "./Bits";

const LAYOUT = [
  "aspect-[4/5] sm:col-span-2 sm:aspect-[4/3] lg:col-span-5 lg:row-span-2 lg:aspect-auto",
  "aspect-[4/5] lg:col-span-3 lg:aspect-auto",
  "aspect-[4/5] lg:col-span-4 lg:aspect-auto",
  "aspect-[4/3] sm:col-span-2 lg:col-span-7 lg:aspect-auto",
  "aspect-[4/3] sm:col-span-2 lg:col-span-7 lg:aspect-auto",
  "aspect-[4/5] sm:col-span-2 sm:aspect-[4/3] lg:col-span-5 lg:row-span-2 lg:aspect-auto",
  "aspect-[4/5] lg:col-span-3 lg:aspect-auto",
  "aspect-[4/5] lg:col-span-4 lg:aspect-auto",
];
import Lightbox from "./Lightbox";

const ProjectCard = ({ p, i, onOpen }) => (
  <motion.figure
    initial={{ opacity: 0, y: 30 }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, amount: 0.15 }}
    transition={{ duration: 0.9, delay: i * 0.08, ease: EASE }}
    className={`group relative overflow-hidden bg-[#1E2228] ${LAYOUT[i]}`}
  >
    <button data-testid={`project-card-${p.id}`} onClick={onOpen} aria-label={`Ampliar imagen: ${p.title}`} className="absolute inset-0 block h-full w-full">
      <img src={p.small} srcSet={`${p.small} 800w, ${p.image} 1600w`} sizes="(min-width: 1024px) 45vw, 100vw" alt={p.alt} loading="lazy" decoding="async" className="h-full w-full object-cover transition-transform duration-[1200ms] ease-out group-hover:scale-105" />
      <span className="absolute inset-0 bg-gradient-to-t from-[#1E2228]/90 via-[#1E2228]/10 to-transparent" />
      <span className="absolute right-4 top-4 grid h-12 w-12 place-items-center rounded-full bg-[#B8955F] text-[#1E2228] opacity-90 transition-transform duration-500 group-hover:scale-110">
        <Expand className="h-4 w-4" />
      </span>
    </button>
    <figcaption className="pointer-events-none absolute inset-x-0 bottom-0 flex items-start gap-4 p-5 sm:p-6">
      <span className="font-serif-it text-xl text-[#E5D3B3]">{p.n}</span>
      <span>
        <span className="block font-display text-sm font-semibold uppercase tracking-[0.12em] text-white">{p.title}</span>
        <span className="mt-1 block max-w-md text-sm text-white/85">{p.desc}</span>
      </span>
    </figcaption>
  </motion.figure>
);

export default function Projects() {
  const [index, setIndex] = useState(null);

  return (
    <section id="proyectos" data-testid="projects-section" className="bg-white py-24 sm:py-32">
      <div className="container-x">
        <div className="mb-12 flex flex-col gap-8 lg:flex-row lg:items-end lg:justify-between">
          <div>
            <Reveal><SectionHead index="02" eyebrow="Proyectos" /></Reveal>
            <h2 className="mt-6 font-display text-3xl font-light uppercase leading-[1.08] text-[#1E2228] sm:text-5xl lg:text-6xl">
              <MaskLine inView>Trabajos</MaskLine>
              <MaskLine inView delay={0.1}><span className="font-serif-it normal-case text-[#8A6C3E]">realizados</span></MaskLine>
            </h2>
          </div>
          <Reveal delay={0.1} className="max-w-sm">
            <p className="text-base leading-relaxed text-[#3A414B]">Fotografías reales de trabajos de ASSE DECOR. Pulsa en cada imagen para verla ampliada.</p>
          </Reveal>
        </div>
        <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-12 lg:auto-rows-[340px] lg:gap-5">
          {PROJECTS.map((p, i) => <ProjectCard key={p.id} p={p} i={i} onOpen={() => setIndex(i)} />)}
        </div>
      </div>
      <Lightbox items={PROJECTS} index={index} onClose={() => setIndex(null)} onIndex={setIndex} />
    </section>
  );
}
